import { sanitize } from '@disco/utils/string-utils'

/**
 * Splits a string by newlines (\n, \r\n and a lone \r).
 *
 * SUB-403: a lone \r is a legitimate line separator (classic Mac encoding, and
 * what iTunes writes into ID3 lyrics frames). CSS `white-space: pre-wrap`
 * treats it as a break, so leaving it out here made the same lyrics render as
 * separate lines in the app and as one run-on line on share pages.
 *
 * @param str - The string to split by newlines
 * @returns Array of string segments split by newlines
 */
export const splitByNewlines: (arg1: string) => string[] = str =>
  str.split(/\r\n|[\r\n]/)

/**
 * Converts text with newlines into HTML with proper line breaks.
 *
 * Each line is wrapped in a div tag, and empty lines are converted to <br> tags.
 * The result is sanitized to prevent XSS attacks.
 *
 * @param text - The text to convert to HTML
 * @returns Sanitized HTML string with proper line breaks
 */
export function newlinesAsHtml(text: string): string {
  return sanitize(
    splitByNewlines(text)
      .map(line => (line ? `<div>${line}</div>` : '<br>'))
      .join('\n'),
  )
}
